import { AnyAction, MiddlewareAPI } from 'redux';
import { ThunkDispatch } from 'store/store';
import Services from 'store/Services';
import { PortfolioActionType } from 'portfolio/store/actions';
import State from 'store/State';
import {
    OrdersActionType,
    ordersFilterResultsChanged,
} from 'app/store/orders/actions';
import { OrderStreamUpdatedEvent } from 'app/store/orders/orderStreamsUpdatedEvent';
import { OrderFilterResultsChangedEventType } from 'app/store/orders/orderFilterResultsChangedEvent';

export const ordersStreamMiddleware = (services: Services) => [
    updateOrdersStreamOnActiveInputChange(services),
    resetFilterWhenMultipleOrdersRemoved(services),
];

export function updateOrdersStreamOnActiveInputChange(services: Services) {
    const { loggingService, portfolioService, ordersStreamingService } =
        services;

    return () => (next: ThunkDispatch<AnyAction>) => (action: AnyAction) => {
        next(action);

        if (action.type !== PortfolioActionType.PORTFOLIO_SET_ACTIVE_INPUT) {
            return;
        }

        if (portfolioService.activeInputUsesOrdersStream) {
            ordersStreamingService.startOrUpdateOrdersStream();

            loggingService.debug(
                'store|updateOrdersStreamOnActiveInputChange',
                `Starting/Updating orders stream`,
                action
            );
        } else {
            ordersStreamingService.stopOrdersStream();

            loggingService.debug(
                'store|updateOrdersStreamOnActiveInputChange',
                `Stopping orders stream`,
                action
            );
        }
    };
}

export function resetFilterWhenMultipleOrdersRemoved(services: Services) {
    const { loggingService } = services;

    return (middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>) =>
        (next: ThunkDispatch<AnyAction>) =>
        (action: AnyAction) => {
            next(action);

            if (action.type !== OrdersActionType.ORDERS_STREAM_UPDATED) {
                return;
            }

            const orderStreamUpdatedEvent =
                action.payload! as OrderStreamUpdatedEvent;

            if (orderStreamUpdatedEvent.multipleOrdersRemoved > 0) {
                loggingService.debug(
                    'store|resetFilterWhenMultipleOrdersCleared',
                    `${orderStreamUpdatedEvent.multipleOrdersRemoved} orders removed - resetting filter`
                );

                middlewareAPI.dispatch(
                    ordersFilterResultsChanged({
                        changedType: OrderFilterResultsChangedEventType.RESET,
                    })
                );
            }
        };
}
